import React from "react";
import { Mongodb, Nodejs, Profile, Reactjs, Redux } from "../assets";
const Header = () => {
  return (
    <div className='w-full flex flex-col lg:flex-row px-4 md:px-10 gap-10 2xl:gap-20 py-20'>
      <div
        className='flex flex-col mb-20 lg:mb-0'
        data-aos='fade-down'
        data-aos-offset='100'
        data-aos-delay='50'
        data-aos-duration='1000'
        data-aos-easing='ease-in-out'
      >
        <span className='text-xl font-bold text-orange-700 pt-10'>
          FULL-STACK BUSINESS SOLUTION DEVELOPER
        </span>
        <div className='flex gap-4 items-center my-4'>
          <h1 className='text-gray-800 dark:text-neutral-100 text-3xl md:text-4xl 2xl:text-3xl font-bold text-center'>
            I'm a
          </h1>
          <div className='flex items-center justify-center text-white shadow-lg bg-blue-800 dark:bg-[#224cff10] dark:text-[#224cff] rounded-full'>
            <p className='text-2xl md:text-4xl 2xl:text-2xl font-bold px-5 py-2 pb-2 text-center'>
              Business Solution Developer
            </p>
          </div>
        </div>

        <h1 className='text-6xl md:text-7xl 2xl:text-6xl font-extrabold text-black dark:text-neutral-100 tracking-wider'>
          Vusi Shongwe
        </h1>

        <p className='text-md text-black dark:text-gray-100 mt-5 2xl:mt-10'>
        Welcome to my corner of the web! I specialize in crafting tailored business solutions and web applications as a Full-Stack Developer. 
        My expertise lies in understanding your organization's unique requirements and processes, allowing me to adapt and customize 
        solutions to fit seamlessly into your workflow. With a commitment to continuous learning and a knack for customization, 
        I'm dedicated to delivering solutions that precisely align with your organizational needs. Let's collaborate to transform 
        your ideas into powerful tools that drive efficiency and success.


        </p>

        <div className='mt-10 flex gap-10'>
          <a href='#footer'>
            <button className='bg-orange-700 text-lg text-white font-semibold rounded-md py-3 px-5'>
              Contact Me
            </button>
          </a>
          <a href='#projects'>
            <button className='text-lg text-white fonnt-semibold rounded-md py-3 px-5 bg-black dark:bg-[#224cff]'>
              Projects
            </button>
          </a>
        </div>
      </div>

      <div className='w-full flex-1 flex justify-center 2xl:pt-10'>
        <div className='w-[300px] h-[300px] md:w-[400px] md:h-[400px] 2xl:w-[500px] 2xl:h-[500px]  border rounded-full border-gray-600 dark:border-gray-200 relative mt-0 md:mt-0 lg:mt-0 flex items-center justify-center'>
          <img
            src={Profile}
            className='w-auto h-[92%] absolute -top-0'
            data-aos='fade-down'
            data-aos-offset='200'
            data-aos-delay='50'
            data-aos-duration='500'
            data-aos-easing='ease-in-out'
          />
          <div
            className='relative w-full h-full rounded-full'
            data-aos='fade-up'
            data-aos-offset='200'
            data-aos-delay='50'
            data-aos-duration='1000'
            data-aos-easing='ease-in-out'
          >
            <img
              src={Reactjs}
              className='absolute top-7 md:top-20 left-3 md:-left-3 2xl:left-2 w-12 h-12 md:w-16 md:h-16'
            />
            <img
              src={Redux}
              className='absolute bottom-7 left-3 md:bottom-10 2xl:left-12 w-12 h-12 md:w-16 md:h-16'
            />
            <img
              src={Mongodb}
              className='absolute top-5 md:top-14 right-3 md:-right-3 2xl:right-2 w-12 h-12 md:w-16 md:h-16'
            />
            <img
              src={Nodejs}
              className='absolute bottom-7 right-3 md:bottom-10 2xl:right-12 w-12 h-12 md:w-16 md:h-16'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
